const ProductJSON = function(){
    const currentVariantJSON = document.querySelector('.current-variant-json');
    const productOptionsJSON = document.querySelector('.product-options-json');
    const productVariantMetaJSON = document.querySelector('#product-variant-meta-json');
    const productDataJSON = document.querySelector('.product-json');
    const productMetaJSON = document.querySelector('.product-meta-json');
    const productVariantInventoryJSON = document.querySelector('.product-variant-inventory-json');
    let productOptions = null;
    let currentVariant = null;
    let productVariantMeta = null;
    let productData = null;
    let productVariantInventory = null;

    try{ currentVariant = JSON.parse(currentVariantJSON.innerHTML)
    }catch( $e ){ currentVariant = false; }
    
    try{ productOptions = JSON.parse(productOptionsJSON.innerHTML)
    }catch( $e ){ productOptions = false; }

    try{ productData = JSON.parse(productDataJSON.innerHTML)
    }catch( $e ){ productData = false; }

    try{ productMeta = JSON.parse(productMetaJSON.innerHTML)
    }catch( $e ){ productMeta = false; }

    try{ productVariantInventory = JSON.parse(productVariantInventoryJSON.innerHTML)
        productVariantInventory = productVariantInventory.map( ( item ) => {
            item.quantity = parseInt( item.quantity );
            item.incoming = item.incoming == 'true' ? true : false;
            return item;
        });
    }catch( $e ){ productVariantInventory = false; }

    try{ 
        productVariantMeta = JSON.parse(productVariantMetaJSON.innerHTML);
        for( let key in productVariantMeta ){
            productVariantMeta[ key ].length = productVariantMeta[ key ].length != null  ? parseFloat( productVariantMeta[ key ].length ) : 0;
            productVariantMeta[ key ].case_quantity = productVariantMeta[ key ].case_quantity != null  ?  productVariantMeta[ key ].case_quantity  : 0;
            productVariantMeta[ key ].moq = productVariantMeta[ key ].moq != null  ?  productVariantMeta[ key ].moq  : false;
            productVariantMeta[ key ].shrink_band_sku = productVariantMeta[ key ].shrink_band_sku != null  ?  productVariantMeta[ key ].shrink_band_sku  : false;
        }        
    }catch( $e ){ productVariantMeta = false; }

    return {
        "currentVariant": currentVariant,
        "productOptions": productOptions,
        "productVariantMeta": productVariantMeta,
        "productData": productData,
        "productMeta": productMeta,
        "productVariantInventory": productVariantInventory
    }
}

export default ProductJSON;